import { create } from "zustand"
import { devtools } from "zustand/middleware"

import { Account } from "@/types/account"
import { Team } from "@/types/team"

export type AccountState = {
  info?: Account
  teamInfo: Team[]
  teamProfileInfo?: Team
  selectedIdfTeam?: number
}

export type AccountStore = AccountState & AccountStateActions

export const defaultAccountState: AccountState = {
  info: undefined,
  teamInfo: [],
  teamProfileInfo: undefined,
  selectedIdfTeam: undefined,
}

export type AccountStateActions = {
  setInfo: (info: Account) => void
  setTeamInfo: (teamInfo: Team[]) => void
  setTeamProfileInfo: (teamProfileInfo: Team) => void
  setSelectedIdfTeam: (selectedIdfTeam: number) => void
}

export const createAccountStore = create<AccountStore>()(
  devtools(
    (set) => ({
      ...defaultAccountState,
      setTeamInfo: (teamInfo: Team[]) => {
        set({ teamInfo }, undefined, "setTeamInfo")
      },
      setTeamProfileInfo: (teamProfileInfo: Team) => {
        set({ teamProfileInfo }, undefined, "setTeamProfileInfo")
      },
      setSelectedIdfTeam: (selectedIdfTeam: number) => {
        set({ selectedIdfTeam }, undefined, "setSelectedIdfTeam")
        localStorage.setItem("selected_team", JSON.stringify({ value: selectedIdfTeam }))
      },
      setInfo: (info: Account) => {
        set({ info }, undefined, "setInfo")
      },
    }),
    {
      store: "account",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
